export const styles = {
  pageWrapper: {
    display: 'flex',
    height: '100vh',
    backgroundColor: '#ede9fe',
  },

  mainContent: {
    flex: 1,
    overflow: 'auto',
    p: 3,
    display: 'flex',
    flexDirection: 'column',
  },

  card: {
    flex: 1,
    borderRadius: 3,
    border: '1px solid #e5e7eb',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#fff',
  },

  title: {
    px: 3,
    pb: 2,
    pt: 0.5,
    fontWeight: 700,
    fontSize: '1.375rem',
    color: '#111827',
    letterSpacing: '-0.02em',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    flex: 1,
    minHeight: 0,
    px: { xs: 2, sm: 2.5 },
    pt: 1.5,
    pb: 2,
    overflow: 'hidden',
  },

  column: {
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '1px solid #e5e7eb',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    '&:first-of-type': {
      borderLeft: 'none',
    },
  },

  columnHeader: {
    py: 2,
    px: 2,
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '0.9375rem',
    color: '#374151',
    borderBottom: '1px solid #e5e7eb',
    backgroundColor: '#fafafa',
  },

  columnBody: {
    flex: 1,
    px: 2.5,
    py: 2.25,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.75,
    overflow: 'auto',
  },

  userCard: {
    borderRadius: 2,
    border: '1px solid #f3f4f6',
    p: 2,
    pt: 1.75,
    backgroundColor: '#fff',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },

  statusRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
  },

  statusDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#22c55e',
    flexShrink: 0,
    mt: '5px',
    boxShadow: '0 0 0 2px #fff, 0 0 0 3px #bbf7d0',
  },

  userName: {
   fontWeight: 700,
    fontSize: '0.9375rem',
    color: '#111827',
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  userDetail: {
    fontSize: '0.8125rem',
    color: '#6b7280',
    mt: 0.25,
  },

  removerBtn: {
    mt: 1.5,
    width: '100%',
    py: 0.75,
    fontWeight: 600,
    fontSize: '0.8125rem',
    textTransform: 'none',
    borderRadius: 1,
    backgroundColor: '#ef4444',
    color: '#fff',
    boxShadow: '0 1px 2px rgba(239,68,68,0.35)',
    '&:hover': {
      backgroundColor: '#dc2626',
    },
  },

  actionsRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    px: 3,
    py: 2,
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#fff',
  },

  confirmarBtn: {
    borderRadius: 999,
    px: 3,
    py: 1,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9375rem',
    backgroundColor: '#ddd6fe',
    color: '#1e1b4b',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#c4b5fd',
    },
  },
};
